import { Dialog, DialogSurface, DialogBody, DialogTitle, DialogContent, DialogActions, Button } from "@fluentui/react-components";
import React from "react";

export default function ReassignApiKeyDialog(
    {
        open,
        setOpen,
        triggerReassignApiKey
    }: {
        open: boolean,
        setOpen: (open: boolean) => void,
        triggerReassignApiKey: () => void
    }
)
{
    return <Dialog open={open} onOpenChange={(_, o) => setOpen(o.open)}>
        <DialogSurface>
            <DialogBody>
                <DialogTitle>Reassign API Key</DialogTitle>
                <DialogContent>
                    <p>Are you sure you want to reassign your API key? This will invalidate your current API key and generate a new one.</p>
                    <p>After reassigning your API key, you will need to update any applications or services that use the API key with the new key.</p>
                    <p>Are you sure you want to proceed?</p>
                </DialogContent>
                <DialogActions>
                    <Button appearance="secondary" onClick={() => setOpen(false)}>Cancel</Button>
                    <Button appearance="primary" onClick={() => { setOpen(false); triggerReassignApiKey(); }}>Reassign</Button>
                </DialogActions>
            </DialogBody>
        </DialogSurface>
    </Dialog>;
}